var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('a',{attrs:{"href":"/admin/dash"}},[_vm._v("Back")])]),_vm._v(" Under constructions ")])
}]

export { render, staticRenderFns }